import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import {AuthenticationResult, PublicClientApplication} from '@azure/msal-browser';
import {environment} from '@env/environment';
import {User} from "@app/Classes/User";
import {JwtHelperService} from "@auth0/angular-jwt";

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private MsalObj: PublicClientApplication;
  private navigationTitle: string;
  public apiAccessToken: string;
  public graphAuthToken: string;
  public accessToken: string;
  public graphToken: string;
  public profile: any = null;
  public currentRoles: string[];
  public GraphTokenName: string = 'graphAuthToken';
  public AuthTokenName: string = 'authToken'
  // tslint:disable-next-line:no-extra-semicolon
  private isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

  public MsalConfig: object = {
    auth: {
      clientId: environment.clientId, // This is your client ID
      authority: `https://login.microsoftonline.com/${environment.tenantId}`, // This is your tenant ID
      redirectUri: environment.redirectUrl, // This is your redirect URI
      postLogoutRedirectUri: environment.postLogoutRedirectUrl,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: this.isIE, // Set to true for Internet Explorer 11
    },
  };

  public SetCredentials(name: string, token: string) {
    sessionStorage.setItem(name, token);
    this.setCookie(name, token, 1,"/"); //tokens only work when from base path
  }

  public setNavigationTitle(title){
    this.navigationTitle = title;
  }

  public getNavigationTitle(){
    return this.navigationTitle;
  }

  public GetCredentials(name: string) {

    if (name === this.AuthTokenName && this.apiAccessToken == null) {
      this.accessToken = sessionStorage.getItem(this.AuthTokenName);
      this.apiAccessToken = this.getCookie(this.AuthTokenName);
    }

    if (name === this.GraphTokenName && this.graphAuthToken) {
      this.graphToken = sessionStorage.getItem(this.GraphTokenName);
      this.graphAuthToken = this.getCookie(this.GraphTokenName);
    }

  }


// @ts-ignore
  constructor(private http: HttpClient, private router: Router, public jwtHelper: JwtHelperService,) {
    this.MsalObj = new PublicClientApplication(this.MsalConfig);
    if (this.profile === null) {
      this.profile = JSON.parse(localStorage.getItem('user'));
    }
    this.GetCredentials(this.AuthTokenName);
    this.GetCredentials(this.GraphTokenName);
  }


  private setCookie (name: string, value: string, expireDays: number, path: string = ''){
    let d:Date = new Date();
    d.setTime(d.getTime() + expireDays *24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` :  '';
    document.cookie = `${name}=${value}; ${expires}; ${cpath}`;
  }

  //deletes cookie on home path and origin path (if necessary for both)
  private deleteCookie(name: string){
    this.setCookie(name, '', -1,'/');
  }

  // Deletes all cookies from path '/'
  private deleteAllCookies() {
    let cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
  }

  private getCookie(name: string){
    const ca: Array<string> = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for(let i: number = 0; i < caLen; i += 1){
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0){
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  async Login() {
      // If already authenticated, navigate to home, else clear cache and continue login flow
      if (this.isAuthenticated()) {
        await this.router.navigate((['home']));
        return;
      }else{
        await this.clearCache();
      }

      // Set scopes for MSAL pull
      const loginScopes = {scopes: ['User.Read', 'openid', 'profile', `${environment.backendAppIdString}`]};
      let loginSuccess = false;
      let accountName;

      // Initial Login attempt for graph token and account information (MSAL popup)
      await this.MsalObj.loginPopup(loginScopes)
        .then((res) => {
          accountName = res.account.username;
          sessionStorage.setItem("accountName",accountName);
          this.graphAuthToken = res.accessToken;
          this.SetCredentials(this.GraphTokenName, res.accessToken);
          loginSuccess = true;
        }).catch(failure => console.log(failure));


      // Verify initial login and that accountName has been saved
      accountName = sessionStorage.getItem('accountName');
      if(!loginSuccess || !accountName) {
        await this.clearCache();
        return new ErrorEvent("Login Failure");
      }

      // Silently grab auth token from MSAL
      await this.silentRefresh(accountName,[`${environment.backendAppIdString}`],this.AuthTokenName,false);

      // Check if tokens are valid, error and return if not valid
      if(!this.isAuthenticated()){
        await this.clearCache();
        return new ErrorEvent("Login Failure");
      }

      // Grab profile info from MSAL
      await fetch(environment.graphMeEndpoint,{
        method: 'GET',
        headers: {
          "Authorization":"Bearer " + this.graphAuthToken,
        }
      })
        .then(response => response.json())
        .then(profile => {
          this.profile = profile;
          localStorage.setItem('user', JSON.stringify(this.profile));
          localStorage.setItem('loggedInAs',JSON.stringify(new User(this.profile.givenName,this.profile.surname,this.profile.employeeId,this.currentRoles)));
        })
        .catch((err) => console.log(err));
    }

  async getTokenForImageList(src: string): Promise<any> {
    const currentAccount = this.MsalObj.getAccountByUsername(this.profile.userPrincipalName);
    const request = {
      scopes: ['User.Read', 'openid', 'profile', 'Files.ReadWrite.All'],
      account: currentAccount,
    };

    await this.MsalObj.acquireTokenSilent(request).then((tokenResponse: AuthenticationResult) : any => {
      this.apiAccessToken = tokenResponse.accessToken;
      const options = {
        method: 'GET',
        headers: {"Authorization": "Bearer " + this.apiAccessToken},
      };
      fetch(src, options)
        .then((resp) => {
          return resp;
        });
    });
  }

  async silentRefresh(accountName,scopes,tokenName, forceRefresh): Promise<void>{
    const currentAccount = this.MsalObj.getAccountByUsername(accountName);
    if(currentAccount == null) return;
    const tokenRequest = {
      scopes: scopes,
      account: currentAccount,
      redirectUri: "",
      forceRefresh:forceRefresh
    };
    await this.MsalObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse =>{
        if(tokenName == this.AuthTokenName){
          this.currentRoles = (<any>tokenResponse.idTokenClaims).roles ?? [];
          this.apiAccessToken = tokenResponse.accessToken;
          this.SetCredentials(this.AuthTokenName, tokenResponse.accessToken);
        }else{
          this.graphAuthToken = tokenResponse.accessToken;
          this.SetCredentials(this.GraphTokenName, tokenResponse.accessToken);
        }
      })
      .catch(function(error: Error){console.log(error.message);});
  }

  async clearCache(): Promise<void>{
    this.profile = null;
    localStorage.clear();
    sessionStorage.clear();
    this.deleteAllCookies();
  }

  async Logout(): Promise<void> {
    this.profile = null;
    localStorage.clear();
    sessionStorage.clear();
    this.deleteAllCookies();
    await this.MsalObj.logout();
  }

  isAuthenticated(): boolean {
    const graphToken = sessionStorage.getItem('graphAuthToken');
    const authToken = sessionStorage.getItem('authToken');
    if(graphToken == null || authToken == null) return false;

    const graphDate = this.jwtHelper.getTokenExpirationDate(graphToken);
    const authDate = this.jwtHelper.getTokenExpirationDate(authToken);
    const currentDate = new Date();

    return currentDate < graphDate && currentDate < authDate;
  }

  public async refreshTokens(){
    const accountName = sessionStorage.getItem("accountName");
    await this.silentRefresh(accountName,[`${environment.backendAppIdString}`],"authToken",true)
    await this.silentRefresh(accountName,['User.Read', 'openid', 'profile', `${environment.backendAppIdString}`],"graphAuthToken",true)
  }
}


